import { Home, FileText, Upload, CreditCard, ClipboardCheck, BarChart3, GraduationCap, Bell, UserCog } from 'lucide-react';
import type { NavItem } from '@/components/layout/RoleLayout';

export const nav: NavItem[] = [
  { to: 'overview', label: 'My application', icon: Home, group: 'Admission' },
  { to: 'application', label: 'Application form', icon: FileText, group: 'Admission' },
  { to: 'documents', label: 'Documents', icon: Upload, group: 'Admission' },
  { to: 'payment', label: 'Pay fee', icon: CreditCard, group: 'Admission' },
  { to: 'exam', label: 'Entrance exam', icon: ClipboardCheck, group: 'Exam & result' },
  { to: 'result', label: 'Exam result', icon: BarChart3, group: 'Exam & result' },
  { to: 'offer', label: 'Admission', icon: GraduationCap, group: 'Exam & result' },
  { to: 'notifications', label: 'Notifications', icon: Bell, group: 'Account' },
  { to: 'account', label: 'Account', icon: UserCog, group: 'Account' },
];
